import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { FieldContainerDirective } from 'src/app/general/directives/field/field-container.directive';
import { FieldDirective } from 'src/app/general/directives/field/field.directive';
import { AdditionalTaxEditorDialogData } from '../interfaces';

// ----------------------------------------------------------------------------
// Usage Example

// Template:

// TS:

// public updateAdditionalTax(tax: proto.waiternow.common.TaxesProto.TaxProto): void {
//   const inputDialogData: AdditionalTaxEditorDialogData = {
//     nameEn: Formatter.getText(tax.name, proto.waiternow.common.Language.ENGLISH),
//     nameEs: Formatter.getText(tax.name, proto.waiternow.common.Language.SPANISH),
//     rate: tax.rate.value
//   }
//   this.additionalTaxEditorDialogService.openEditor(
//     inputDialogData,
//     /* onUpdate */ outputDialogData => {
//       // Updates values in tax. If the rate is removed, delete the tax.
//     }
//   );
// }

// ----------------------------------------------------------------------------

@Component({
  selector: 'app-additional-tax-editor-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    TranslateModule,
    FieldContainerDirective,
    FieldDirective
  ],
  templateUrl: './additional-tax-editor-dialog.component.html',
  styleUrls: ['./additional-tax-editor-dialog.component.css']
})
export class AdditionalTaxEditorDialogComponent {

  constructor(
      public dialogRef: MatDialogRef<AdditionalTaxEditorDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: AdditionalTaxEditorDialogData) {
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  public isValidTax(): boolean {
    if ((!this.data.nameEn || this.data.nameEn.trim() === '')  && (!this.data.nameEs || this.data.nameEs.trim() === '')) {
      return false;
    }
    if (!this.data.rate || this.data.rate.trim() === '') {
      return false;
    }
    const rateNumber = Number(this.data.rate);
    if (rateNumber <= 0 || rateNumber > 1) {
      return false;
    }
    return true;
  }
}
